const Default = ({
  currentImage,
  L0OuterL2,
  L0OuterL3,
  L0OuterL4,
  L0OuterL5,
  L0OuterL6,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl0" ? "hidden" : ""}`}>
      <div className="" id="imagedivl0">
        {/* <div className="flex justify-center mb-4 text-lg font-semibold text-blue-700">
          <p>Choose Level</p>
        </div> */}
        <div>
          <img
            src="assets/images/LearningWheel0.png"
            useMap="#lw00"
            className="w-80 h-80"
            alt=""
          />
          <map name="lw00" id="lw00">
            <area
              className="cursor-pointer"
              alt="L0 Outer 2"
              onClick={L0OuterL2}
              coords="719,1088,754,1181,882,1142,1011,1055,1092,965,1140,893,1186,797,1079,754,1023,874,950,961,854,1033"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L0 Outer 3"
              onClick={L0OuterL3}
              coords="957,110,890,213,999,312,1060,426,1094,557,1095,610,1212,610,1205,489,1172,369,1103,249,1046,184"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L0 Outer 4"
              onClick={L0OuterL4}
              coords="277,115,346,215,437,171,538,139,653,133,761,151,782,27,660,11,514,13,387,54"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L0 Outer 5"
              onClick={L0OuterL5}
              coords="18,680,141,667,138,547,165,455,193,382,236,307,288,256,181,190,126,261,78,333,32,455,23,535"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L0 Outer 6"
              onClick={L0OuterL6}
              coords="610,1201,613,1094,477,1074,381,1030,307,979,223,885,117,931,184,1015,253,1081,359,1143,475,1184,536,1193"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Default;
